import { T } from "@/locales";

export default {
  number: [
    { required: true, message: T("请输入批次编号"), trigger: "change" },
    { max: 32, message: T("超出最大长度 (32)"), trigger: "change" },
  ],
};
